import { BaseOutputParser } from "../schema/output_parser.js";
export class AgentActionOutputParser extends BaseOutputParser {
}
